import React from 'react';
import { Alert, Button, Container, Box } from '@mui/material';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error capturado por boundary:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Container maxWidth="sm">
                    <Box sx={{ mt: 8 }}>
                        <Alert severity="error">
                            <h2>Algo salió mal</h2>
                            <p>{this.state.error?.message || 'Error desconocido'}</p>
                            <Button
                                variant="contained"
                                onClick={() => window.location.reload()}
                                sx={{ mt: 2 }}
                            >
                                Recargar Aplicación
                            </Button>
                        </Alert>
                    </Box>
                </Container>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
